import * as React from 'react';
import { CoreBumpRecommendationListing } from '../../schemas/rql';
import { ChildProps, graphql } from 'react-apollo';
import {
  MAX_BUMP_AMOUNT_PERCENT,
  MIN_BUMP_AMOUNT_PERCENT,
} from '../shared/constants';
import { fixPrecision, shouldGetBuyBoxRecommendation } from './bump_helpers';
import { BumpModal } from './bump_modal';
import { BUMPED_LISTING_RECOMMENDATION_QUERY, CoreBumpListingCardQueryProps } from './bump_listing_query';

export interface BumpV2ModalContainerProps {
  listingId: string;
  bid: number;
  selectedBid: number;
  successMessage: string;
  failMessage: string;
  handleBidChange: (bid: number) => void;
  updateBid: (
    bid: number,
    bumpRecommendationAmount: number,
    listing: CoreBumpRecommendationListing.Listing,
    refetch: () => void,
  ) => void;
  refetch: () => void;
  onRequestClose?: Function;
}

type Props = ChildProps<BumpV2ModalContainerProps &
CoreBumpListingCardQueryProps,
CoreBumpRecommendationListing.Query
>;

// a new listing that is CSP matched should get the maxBumpRecommendationAmount
// otherwise return the bumpRecommendationAmount
export function recommendationAmount(
  listing: CoreBumpRecommendationListing.Listing,
): number {
  const mediumRecommendationAmount = listing.bumpRecommendations.bumpRecommendationAmount;
  const maxRecommendationAmount = listing.bumpRecommendations.maxBumpRecommendationAmount;

  const amount = shouldGetBuyBoxRecommendation(listing) ? maxRecommendationAmount : mediumRecommendationAmount;

  // return a recommendation amount that is greater than or equal to the min (0.5%) and less than or equal to max 30%
  return fixPrecision(Math.min(Math.max(amount, MIN_BUMP_AMOUNT_PERCENT), MAX_BUMP_AMOUNT_PERCENT));
}

export function BumpV2ModalContainer(props: Props) {

  const loading = props.data?.loading;
  const listing = props.data?.listing;

  if (loading || !listing) {
    return null;
  }

  const bumpRecommendationAmount = recommendationAmount(
    listing,
  );

  return (
    <BumpModal
      recommendationAmount={bumpRecommendationAmount}
      listing={listing}
      bid={props.bid}
      selectedBid={props.selectedBid}
      handleBidChange={props.handleBidChange}
      updateBid={props.updateBid}
      successMessage={props.successMessage}
      failMessage={props.failMessage}
      refetch={props.refetch}
      onRequestClose={props.onRequestClose}
    />
  );
}

const coreBumpRecommendationListingCardQuery = graphql<
BumpV2ModalContainerProps,
CoreBumpRecommendationListing.Query
>(
  BUMPED_LISTING_RECOMMENDATION_QUERY,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default coreBumpRecommendationListingCardQuery(BumpV2ModalContainer);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_v2_modal_container.tsx